export function Admin() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="layer-single">
        <path
          id="Icon"
          d="M8.23721 4.78499C8.14976 4.74126 8.10603 4.7194 8.06016 4.71079C8.01954 4.70317 7.97785 4.70317 7.93723 4.71079C7.89137 4.7194 7.84764 4.74126 7.76018 4.78499L1.33203 7.99907L7.76018 11.2131C7.84764 11.2569 7.89137 11.2787 7.93723 11.2873C7.97785 11.295 8.01954 11.295 8.06016 11.2873C8.10603 11.2787 8.14976 11.2569 8.23721 11.2131L14.6654 7.99907L8.23721 4.78499Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
